import { storeJsonData, getJsonData } from "./StoreService";
import findIndex from "lodash/findIndex";
import isArray from "lodash/isArray";
const KEY = "SEARCH";

export const getHistory = async () => {
  const history = await getJsonData(KEY);
  return history || [];
};

export const storeHistory = async (w) => {
  const words = new KeyWords(w);
  const history = await getJsonData(KEY);
  if (!history) {
    await storeJsonData(KEY, new Array(words));
  }
  if (!isArray(history)) {
    return null;
  }
  const exist = findIndex(history, (i) => i.words === w);
  if (exist > -1) {
    history.splice(exist, 1);
  }
  if (history.length >= 10) {
    history.pop();
  }
  await storeJsonData(KEY, [words, ...history]);
  return words;
};
export const deleteHistory = async () => {
  await storeJsonData(KEY, []);
};
class KeyWords {
  words;
  time;
  constructor(w, t) {
    this.words = w;
    this.time = 1;
  }
}
